import { render } from "./BarWaveLoader.vue?vue&type=template&id=4a8942c4"
import script from "./BarWaveLoader.vue?vue&type=script&lang=js"
export * from "./BarWaveLoader.vue?vue&type=script&lang=js"

import "./BarWaveLoader.vue?vue&type=style&index=0&id=4a8942c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__